module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino_evault_logo_dark-9d66ca394e80eda4f02635567d00d3ef.svg";